import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemindersComponent } from './reminders.component';
import { NbButtonModule, NbCardModule, NbIconModule, NbAccordionModule } from '@nebular/theme';
import { FlexLayoutModule } from '@angular/flex-layout';

const component = RemindersComponent

@NgModule({
  declarations: [component],
  imports: [
    CommonModule,
    NbIconModule,
    NbCardModule,
    FlexLayoutModule,
    NbButtonModule,
    NbAccordionModule
  ],
  exports: [component]
})
export class RemindersModule { }
